import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SharedModule } from '../../../_shared/shared.module';

import { Country } from '../../shared/country.model';
import { CountryDetailComponent } from '../../country-detail/country-detail.component';

@Component({
  selector: 'app-country-modal',
  templateUrl: './country-modal.component.html',
  standalone: true,
  imports: [SharedModule, CountryDetailComponent],
})
export class CountryModalComponent {
  constructor(
    private ref: MatDialogRef<CountryModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  // @Output() dialogSaved = new EventEmitter<any>(); // avoid closing the dialog

  modalTitle = this.data.title;
  country: Country = this.data.obj;
  defaultLanguage = this.data.params.defaultLanguage;
  additionalLanguages = this.data.params.additionalLanguages;

  // Referenced from app-country-detail
  onSavedCountry(country) {
    // this.dialogSaved.emit(country); // avoid closing the dialog

    this.ref.close(country); // close the dialog
  }

  // Referenced from app-country-detail
  onCanceledCountry() {
    this.close();
  }

  close() {
    this.ref.close();
  }
}
